import React from 'react';
import { useFeature } from 'flagged';
import QueuePendingIndicator from './QueuePendingIndicator';
import QueueStatusIndicator from './QueueStatusIndicator';

const QueueStatusIndicatorControl = ({ row }) => {
  const featureEnabled = useFeature('queue_pa_status_indicator_p2p');
  return featureEnabled ? (
    <QueueStatusIndicator row={row} />
  ) : (
    <QueuePendingIndicator row={row} />
  );
};

export default QueueStatusIndicatorControl;
